
import { City } from '../types/city-types';

// Mock cities data for Hidalgo
export const hidalgo_cities: City[] = [
  {
    city_id: 'PCH',
    name: 'Pachuca',
    coordinates: [-98.7313, 20.1167], // Verified coordinates
    population: 277375,
    church_presence: 'Medium',
    region_id: 'HGO',
    churches_count: 28,
    missionaries: 8,
    funding_amount: 63000,
    funding_percentage: 53,
    pledges: 35000,
    unreached_percentage: 55,
    image_url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Reloj_Monumental_de_Pachuca%2C_Hidalgo.jpg/1024px-Reloj_Monumental_de_Pachuca%2C_Hidalgo.jpg',
    description: 'Pachuca is the capital city of Hidalgo with a growing evangelical presence, though many neighborhoods remain unreached.'
  },
  {
    city_id: 'TLC',
    name: 'Tulancingo',
    coordinates: [-98.3640, 20.0881], // Verified coordinates
    population: 151584,
    church_presence: 'Low',
    region_id: 'HGO',
    churches_count: 14,
    missionaries: 5,
    funding_amount: 32000,
    funding_percentage: 27,
    pledges: 18500,
    unreached_percentage: 73,
    image_url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Vista_Tulancingo.jpg/1280px-Vista_Tulancingo.jpg',
    description: 'Tulancingo is the second-largest city in Hidalgo and has several established churches, but many areas remain without evangelical presence.'
  },
  {
    city_id: 'HDR',
    name: 'Huejutla de Reyes',
    coordinates: [-98.4203, 21.1394], // Adjusted coordinates to be within Hidalgo
    population: 45069,
    church_presence: 'Unreached',
    region_id: 'HGO',
    churches_count: 5,
    missionaries: 3,
    funding_amount: 22000,
    funding_percentage: 18,
    pledges: 14500,
    unreached_percentage: 87,
    image_url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Huejutla.jpg/1280px-Huejutla.jpg',
    description: 'Huejutla is located in the Huasteca region of Hidalgo with a significant Nahuatl-speaking population and low evangelical presence.'
  },
  {
    city_id: 'IXM',
    name: 'Ixmiquilpan',
    coordinates: [-99.2193, 20.4793], // Adjusted coordinates to be within Hidalgo
    population: 36026,
    church_presence: 'Low',
    region_id: 'HGO',
    churches_count: 6,
    missionaries: 4,
    funding_amount: 28000,
    funding_percentage: 23,
    pledges: 16800,
    unreached_percentage: 76,
    image_url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Ixmiquilpan%2C_Hidalgo%2C_M%C3%A9xico.jpg/1280px-Ixmiquilpan%2C_Hidalgo%2C_M%C3%A9xico.jpg',
    description: 'Ixmiquilpan has a significant Otomi indigenous population and is known for its traditional culture, creating challenges for church planting.'
  },
  {
    city_id: 'TLA',
    name: 'Tula de Allende',
    coordinates: [-99.3427, 20.0613], // Adjusted coordinates to be within Hidalgo
    population: 28432,
    church_presence: 'Low',
    region_id: 'HGO',
    churches_count: 8,
    missionaries: 3,
    funding_amount: 24000,
    funding_percentage: 20,
    pledges: 13000,
    unreached_percentage: 68,
    image_url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Los_atlantes_de_Tula.jpg/1280px-Los_atlantes_de_Tula.jpg',
    description: 'Tula is historically significant as the ancient capital of the Toltec civilization and now has an industrial base with workers who need gospel outreach.'
  }
];

// Get a city by ID from the Hidalgo cities data
export const getCityById = (cityId: string): City | undefined => {
  return hidalgo_cities.find(city => city.city_id === cityId);
};

// Get funding percentage for a city
export const getCityFundingPercentage = (city: City): number => {
  // If the city already has a funding_percentage, use that
  if (city.funding_percentage !== undefined) {
    return city.funding_percentage;
  }
  
  // Otherwise calculate a reasonable value based on church presence
  const basePercentage = {
    'High': 70,
    'Medium': 40,
    'Low': 20,
    'Unreached': 8
  }[city.church_presence] || 0;
  
  // Add some randomness to make it look more realistic
  return basePercentage + Math.floor(Math.random() * 15);
};
